export const ADJUSTABLE = "adjustable";
export const FRONT_WALL = "front-wall";
export const LEFT_WALL = "left-wall";
export const RIGHT_WALL = "right-wall";
export const BACK_WALL = "back-wall";
export const ROOM_SURFACE = "room-surface";
export const WALL_KEYS = [
    FRONT_WALL,
    LEFT_WALL,
    RIGHT_WALL,
    BACK_WALL,
    ROOM_SURFACE,
];
export const ADJUSTABLE_CONNECTOR = "adjustable-connector";
export const VIEWER_OBJECT_CONNECTOR = "viewer-object-connector";
